import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { IntegrationFormSchema } from '../schemas';
import { z } from 'zod';

export const TuyaIntegrationFormSchema = z
  .object({
    tuyaUserId: z
      .string({ message: MANDATORY_FIELD })
      .nonempty({ message: MANDATORY_FIELD }),
  })
  .merge(IntegrationFormSchema);
